// 常駐活動中獎名單彈窗
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { popState, setCampaignWinnerModal } from '@/slices/popSlice';
import campaignClient from '@/common/apiClient/campaignClient';
import CampaignEmptyRecord from './CampaignEmptyRecord';

const CampaignWinningList = ({ spinSlug }) => {
    const dispatch = useDispatch();
    const { showCampaignWinner } = useSelector(popState);

    const [winnerList, setWinnerList] = useState(null); // 中獎名單

    // 取得中獎名單
    const getWinnerList = async () => {
        try {
            const result = await campaignClient.getWinnerList(spinSlug);
            if (result) setWinnerList(result || {});
        } catch (e) {
            console.error(e);
        }
    };

    // 關閉彈窗
    const onClose = () => dispatch(setCampaignWinnerModal(false));

    useEffect(() => {
        getWinnerList();
    }, []);

    return (
        <div id="campaign-winner-modal" className={`modal ${showCampaignWinner ? 'act' : ''}`}>
            <div
                className="relative z-[1] border-1 border-[#fff] border-opacity-[.3] rounded-[22px] w-[667px] max-w-[96%] max-h-[96vh]
            bg-[#000] bg-opacity-[.44] backdrop-blur-[9px] px-[40px] py-[30px] usm:px-[20px]"
            >
                <p className="text-[#fff] text-center text-h5">中獎名單</p>

                <div className="max-h-[calc(96vh-130px-57px)] noScrollY">
                    {/* 有開獎紀錄 */}
                    {winnerList && Object.keys(winnerList)?.length > 0 ? (
                        Object.keys(winnerList)?.map((time, i) => (
                            <div
                                key={time + 'winning' + i}
                                className={`py-[35px] border-[#393939] [&>div]:flex [&>div]:items-center text-[#fff] [&>div]:text-bd1m [&>div]:gap-x-[25px]
                                [&>div>p]:flex-grow [&_span]:w-[148px] [&_span]:flex-shrink-0 space-y-[12px] ${
                                    i < Object.keys(winnerList)?.length - 1 ? 'border-b-1' : ''
                                }`}
                            >
                                <div className="!text-btn1b">
                                    <p>{time}</p>
                                    <span>中獎者</span>
                                </div>
                                {winnerList?.[time]?.map((prize, index) => (
                                    <div key={prize?.awardName + index}>
                                        <p>{prize?.awardName}</p>
                                        <span className="tabular-nums">@{prize?.uid}</span>
                                    </div>
                                ))}
                            </div>
                        ))
                    ) : (
                        // 還沒有中獎紀錄
                        <CampaignEmptyRecord type="list" />
                    )}
                </div>

                <button
                    onClick={onClose}
                    className="px-[35px] h-[29px] mt-[35px] block mx-auto py-[6px] rounded-[4px] text-bd4n text-[#fff] bg-[#fff] bg-opacity-[.11]"
                >
                    關閉
                </button>
            </div>

            {/* 關閉用背景 */}
            <div className="close-bg" onClick={onClose} />
        </div>
    );
};

export default CampaignWinningList;
